import LoginInputForm from './LoginInputForm';

export default LoginInputForm;
